declare namespace $ {

	export class $bog_ui_divider extends $mol_view {
	}
	
}

//# sourceMappingURL=divider.view.tree.d.ts.map